import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState,useEffect,useMemo } from "react";

const CourseModule = ({ module, level }) => {
  const navigate = useNavigate();
  const { profileUser } = useAuth();
  const [popUp,setPopUp]=useState(false);
  const addon = useMemo(() => ({
  b: 0,
  i: 600,
  a: 1100
 }), []);

  const isDemoModule = module.moduleId === "BM1";
  const levelKey = module.moduleId[0].toLowerCase();
  const moduleNumber = Number(module.moduleId.slice(2));

const cost = useMemo(() => {
  if (levelKey === "b") {
    return moduleNumber === 1
      ? 0
      : 100 + (moduleNumber - 2) * 50;
  }

  return 50 + (moduleNumber - 1) * 50 + addon[levelKey];
}, [levelKey, moduleNumber, addon]); // ✅ added addon



  const handleClick = () => {
    if (!isDemoModule && !profileUser?.hasPremiumAccess) {
      navigate("/about", {
        state: { scrollToDemo: true },
      });
      return;
    }
    if(profileUser.goldPoints>=cost ){
        navigate(`/courses/${level.toLowerCase()}/${module.moduleId}`);
      }else{
        setPopUp(true);
      } 
  };

  useEffect(() => {
  if (popUp) {
    const timer = setTimeout(() => {
      setPopUp(false);
    }, 3000); // disappears after 3 seconds

    return () => clearTimeout(timer); // cleanup if component re-renders
  }
}, [popUp]);

  return (
    <div
      className="course-module"
      style={{ cursor: "pointer" }}
      onClick={handleClick}
    >
      <div className="module-header">
        <span>{module.moduleId}</span>

        {!isDemoModule && !profileUser?.hasPremiumAccess && (
          <span className="module-lock">🔒 Demo Required</span>
        )}

        <span className="module-arrow">{cost} 🪙</span>
     

       

      </div>
      {popUp &&
          <div className="popup-message" onClick={()=>setPopUp(false)}>
            Earn {cost-profileUser.goldPoints} gold points to unlock this module
          </div>
        }
    </div>
  );
};

export default CourseModule;
